import { useMemo, useState } from "react"
import { cn } from "../../../lib/utils"
import { CoverBookEdge } from "./CoverBookEdge"
import { CoverImageElement } from "./CoverImageElement"
import { CoverTextElement } from "./CoverTextElement"
import { CoverRenderData } from "./types"

interface CoverPreviewProps {
  data?: CoverRenderData
  className?: string
  showBookEdge?: boolean
}

export const CoverPreview: React.FC<CoverPreviewProps> = ({
  data,
  className = "",
  showBookEdge = true,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const {
    aspectRatio = 1,
    backgroundColor = "#ffffff",
    backgroundStyle = {},
    regionBackgroundUrl,
    albumDirection = "RTL",
    imageElements = [],
    textElements = [],
  } = data || {}

  const safeAspectRatio = useMemo(
    () => (aspectRatio && aspectRatio > 0 ? aspectRatio : 1),
    [aspectRatio]
  )

  return (
    <div
      className={cn(
        "relative overflow-hidden transition-all duration-300",
        "shadow-lg hover:shadow-xl",
        className
      )}
      style={{
        aspectRatio: safeAspectRatio.toString(),
        backgroundColor,
        ...backgroundStyle,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {regionBackgroundUrl && (
        <img
          src={regionBackgroundUrl}
          alt="Region background"
          className="absolute top-0 pointer-events-none w-full h-full object-cover"
          style={{
            zIndex: 1,
          }}
        />
      )}

      {showBookEdge && (
        <CoverBookEdge albumDirection={albumDirection} isHovered={isHovered} />
      )}

      {imageElements.map((element, index) => (
        <CoverImageElement
          key={element.id ?? index}
          imageUrl={element.imageUrl}
          style={element.style}
        />
      ))}

      {textElements.map((element) => (
        <CoverTextElement
          key={element.id}
          element={element}
          albumDirection={albumDirection}
        />
      ))}

      <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_8px_rgba(0,0,0,0.2)] z-1" />
    </div>
  )
}
